import { Phone, Mail, Facebook, Instagram, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";

const SERVICE_LINKS = [
  { label: "Roof Installation", href: "/services/roof-installation" },
  { label: "Roof Repair", href: "/services/roof-repair" },
  { label: "Roof Inspection", href: "/services" },
  { label: "Emergency Services", href: "/contact" },
  { label: "All Services", href: "/services" },
  { label: "About Us", href: "/about" },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative shingle-texture bg-[#0a0a0a] border-t border-white/10 pt-20 pb-10"
    >
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16">
          {/* Logo & blurb */}
          <div className="md:col-span-4">
            <div className="flex flex-col leading-none mb-6">
              <span className="font-display font-extrabold text-3xl uppercase tracking-wider text-white">
                Crestline
              </span>
              <span className="font-display font-medium text-xs uppercase tracking-[0.35em] text-[var(--crest-amber)] -mt-1">
                Roofing
              </span>
            </div>
            <p className="font-body text-sm text-white/55 leading-relaxed max-w-sm">
              Premium roofing for British Columbia homes. Built once, built
              right, backed in writing.
            </p>
            <div className="mt-8 flex items-center gap-4">
              <a
                href="#"
                data-testid="social-facebook"
                aria-label="Facebook"
                className="w-10 h-10 flex items-center justify-center border border-white/15 text-white/60 hover:text-[var(--crest-amber)] hover:border-[var(--crest-amber)] transition-colors"
              >
                <Facebook size={16} strokeWidth={1.5} />
              </a>
              <a
                href="#"
                data-testid="social-instagram"
                aria-label="Instagram"
                className="w-10 h-10 flex items-center justify-center border border-white/15 text-white/60 hover:text-[var(--crest-amber)] hover:border-[var(--crest-amber)] transition-colors"
              >
                <Instagram size={16} strokeWidth={1.5} />
              </a>
              <a
                href="#"
                data-testid="social-linkedin"
                aria-label="LinkedIn"
                className="w-10 h-10 flex items-center justify-center border border-white/15 text-white/60 hover:text-[var(--crest-amber)] hover:border-[var(--crest-amber)] transition-colors"
              >
                <Linkedin size={16} strokeWidth={1.5} />
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="md:col-span-4">
            <h4 className="font-display uppercase tracking-[0.3em] text-xs font-semibold text-[var(--crest-amber)] mb-6">
              Services
            </h4>
            <ul className="grid grid-cols-2 gap-y-3">
              {SERVICE_LINKS.map((s) => (
                <li key={s.label}>
                  <Link
                    to={s.href}
                    data-testid={`footer-link-${s.label.toLowerCase().replace(/\s/g, "-")}`}
                    className="font-body text-sm text-white/70 hover:text-white transition-colors"
                  >
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <h4 className="font-display uppercase tracking-[0.3em] text-xs font-semibold text-[var(--crest-amber)] mb-6">
              Get in touch
            </h4>
            <a
              href="tel:+17789176817"
              data-testid="footer-phone"
              className="flex items-center gap-3 text-white hover:text-[var(--crest-amber)] transition-colors mb-4 group"
            >
              <span className="w-9 h-9 flex items-center justify-center bg-[#1a1a1a] border border-white/10 group-hover:border-[var(--crest-amber)] transition-colors">
                <Phone size={14} strokeWidth={1.8} />
              </span>
              <span className="font-display font-bold text-lg tracking-tight">
                (778) 917-6817
              </span>
            </a>
            <a
              href="mailto:info@crestlineroofing.ca"
              data-testid="footer-email"
              className="flex items-center gap-3 text-white hover:text-[var(--crest-amber)] transition-colors mb-6 group"
            >
              <span className="w-9 h-9 flex items-center justify-center bg-[#1a1a1a] border border-white/10 group-hover:border-[var(--crest-amber)] transition-colors">
                <Mail size={14} strokeWidth={1.8} />
              </span>
              <span className="font-body font-medium text-sm md:text-base">
                info@crestlineroofing.ca
              </span>
            </a>
            <div className="font-body text-xs text-white/40 leading-relaxed">
              Serving the Lower Mainland
              <br />
              Burnaby · Vancouver · Surrey · Coquitlam · Richmond
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="font-body text-xs text-white/40 tracking-wide">
            © 2026 Crestline Roofing Ltd. — Licensed &amp; Insured
          </div>
          <nav
            data-testid="footer-legal"
            className="flex items-center gap-4 font-body text-[11px] uppercase tracking-[0.25em] text-white/50"
          >
            <Link
              to="/privacy-policy"
              data-testid="footer-link-privacy-policy"
              className="hover:text-[var(--crest-amber)] transition-colors"
            >
              Privacy Policy
            </Link>
            <span className="text-white/15">·</span>
            <Link
              to="/terms"
              data-testid="footer-link-terms"
              className="hover:text-[var(--crest-amber)] transition-colors"
            >
              Terms of Service
            </Link>
          </nav>
          <div className="font-body text-[10px] uppercase tracking-[0.3em] text-white/30">
            License No. CR-2026-0142 · WCB #C-44829
          </div>
        </div>
      </div>
    </footer>
  );
}
